import {
  TextInputFormikField,
  NumberFieldFormikField,
  RadioGroupFormikField,
  Radio,
  SelectFormikField,
  SelectItem,
} from "@certn/cascadia-react";
import { Stack, Text } from "@certn/cascadia";
import { components } from "@certn/api/generated-schemas/applicant-portal";
import { splitLabelHeader } from "@certn/api";
import { Trans } from "react-i18next";

type Claim = components["schemas"]["CustomQuestionnaireTemplateInputClaim"];

type Props = Claim & {
  onChange: (value: string | number | boolean | null) => void;
};

// Created this component for Fitness check. It was previously using CustomQuestionnaireField.tsx and the updates
// added to it broke Custom Questionnaire logic.
export function FitnessField({ onChange, ...claim }: Props) {
  const { header, fieldLabel } = splitLabelHeader(claim.label);
  const testID = `custom-questionnaire-field-${claim.name}`;

  const commonFieldProps = {
    ...claim,
    label: fieldLabel,
    isRequired: claim.is_optional !== true,
    testID,
    onChange,
  };

  const field = renderField(claim, commonFieldProps);

  if (!header) {
    return field;
  }

  return (
    <Stack gap="space-2">
      <Text style="form/body-primary" testID={`${testID}-header`}>
        {header}
      </Text>
      {field}
    </Stack>
  );
}

type CommonFieldProps = Props & {
  label: string;
  isRequired: boolean;
  testID: string;
};

function renderField(claim: Claim, commonFieldProps: CommonFieldProps) {
  if (claim.type === "str") {
    const constraints = claim.constraints ? claim.constraints[0] : undefined;
    const hasSelectableOptions = !!constraints;

    if (hasSelectableOptions) {
      const selectableOptions = constraints.selectable_options;

      return (
        <SelectFormikField {...commonFieldProps}>
          {selectableOptions.map((option) => (
            <SelectItem key={option.value} id={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectFormikField>
      );
    }

    return (
      // Need a multi line version
      // TextAreaFormikField would go here
      <TextInputFormikField {...commonFieldProps} />
    );
  }
  if (claim.type === "int" || claim.type === "float") {
    return (
      <NumberFieldFormikField
        {...commonFieldProps}
        step={claim.type === "float" ? 0.1 : 1}
        defaultValue={0}
      />
    );
  }
  if (claim.type === "bool") {
    return (
      <RadioGroupFormikField {...commonFieldProps} orientation="horizontal">
        <Radio
          value="true"
          testID={`custom-questionnaire-field-${claim.name}-true-radio-button`}
        >
          <Trans>Yes</Trans>
        </Radio>
        <Radio
          value="false"
          testID={`custom-questionnaire-field-${claim.name}-false-radio-button`}
        >
          <Trans>No</Trans>
        </Radio>
      </RadioGroupFormikField>
    );
  }
  if (claim.type === "file_upload") {
    console.warn("File upload field type not implemented yet");
    // file_upload type goes here
    return <></>;
  }
  return <></>;
}
